import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const NoSearchResult = ({ searchText, reset }) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '1.125rem', mt: 8 }}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <Typography>
                    No orders found for order ref: "{searchText}"
                </Typography>
                <Box onClick={reset} sx={{
                    cursor: 'pointer',
                    mt: 2,
                    marginTop: '16px',
                    textAlign: 'center',
                    backgroundColor: '#000000',
                    color: '#ffffff',
                    width: 'fit-content',
                    padding: '0.825rem',
                    borderRadius: '10px',
                    fontSize: '0.875rem'
                }}>Close Result</Box>
            </Box>
        </Box>
    );
}

export default NoSearchResult;